// let BASE_API_URL = "http://121.196.212.2:8080";
// let BASE_API_URL = "http://km.zzly99.com:8080";
// 山西长护险正式环境
// let BASE_API_URL = "https://h5.zzly99.com";
// 福建长护险正式环境
// let BASE_API_URL = "https://admin.hongjianhl.com";
// 中福康正式环境
// let BASE_API_URL = "https://chx.zfkang.com";
// 中福康正式环境2
// let BASE_API_URL = "https://chxian.zfkang.com";
// 钱兄长护险正式环境
let BASE_API_URL = "https://qianxiongdp.zfkang.com";

module.exports = {
  BASE_API_URL,
};
